/**
 * Wrap item in array if it's not an array already
 *
 * @param {any} arg - If x is not an array, wrap it in one
 * @returns {any[]}
 */

const asArray = (arg: any): any[] => (arg !== undefined && arg !== null ? (Array.isArray(arg) ? arg : [arg]) : []);

export default asArray;
